// @flow
import classify from '@src/utils/typestyle';

import LinkPopup from '@components/popups/Link';
import * as SampleImageContent from '@components/popups/content/SampleImage';

import { linkBlueText } from '@src/styles/general';

const classes = classify({
  link: {
    color: linkBlueText,
    $nest: {
      '&:hover': {
        color: linkBlueText,
        textDecoration: 'underline'
      }
    }
  },
  sampleImage: {
    marginTop: '12px',
    marginBottom: '29px',
    fontSize: '13px',
    lineHeight: '16px',
    textAlign: 'center',
    color: '#908e8e'
  }
});

export default function SampleImageWithLink({ url }: { url: string }) {
  return (
    <div style={{ position: 'relative' }}>
      <p className={classes.sampleImage}>
        <span>This is a </span>
        <LinkPopup initialContent={SampleImageContent}>
          <span className={classes.link}>sample image</span>
        </LinkPopup>
        <span>; see <a href={url} className={classes.link} target='_blank'>actual image</a>.</span>
      </p>
    </div>
  );
}
